export const mfManifestsPath = '/assets/module-federation.manifest.dev3.json'
